// @ts-nocheck
// tslint:disable
/**
 * PalmApp Server Web API v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { TransactionState } from './transaction-state';
import { TransactionType } from './transaction-type';

// tslint:disable
import { APIModel, APIModelOptions, AttributeMapItem } from "../base";

export class TransactionHistoryResponse extends APIModel {
    id: number;
    amount: number;
    state: TransactionState;
    dateRequested: string;
    transactionType: TransactionType;
    description: string;

    constructor(options?: APIModelOptions) {
        super(TransactionHistoryResponse.attributeTypeMap, options);
    }

    static get attributeTypeMap(): Array<AttributeMapItem> {
        return [
            { name: "id", type: "number" },
            { name: "amount", type: "number" },
            { name: "state", type: "TransactionState" },
            { name: "dateRequested", type: "string" },
            { name: "transactionType", type: "TransactionType" },
            { name: "description", type: "string" }
        ];
    }
}




